import { JobRecord } from '../jobRecordsApi';
import { ComponentEntityType, ComponentType } from './componentsApi';
import { ChatMessage, UnionChatMessage } from './messageTypes';

export type AiActionPerformed = 'thread-created' | 'article-created';

export interface AiChatMessage extends ChatMessage {
  chunks: AiMessageChunk[];
  role: 'Assistant';
  performedActions: AiActionPerformed[];
}

export interface AiMessageChunk {
  order: number;
  text: string;
  componentId: number | null;
  componentType: ComponentType | null;
  componentEntityType: ComponentEntityType | null;
}

export interface ChatItems {
  chatMessages: Record<number, UnionChatMessage>;
  jobs: Record<number, JobRecord>;
  items: ChatItem[];
}

export interface ChatItem {
  type: ChatItemType;
  id: number;
}

export enum ChatItemType {
  Message = 1,
  Job = 2,
}
